import { hash } from '@ember/helper';
import FlexColumn from '../layout/flex/column.gjs';
import StandardBody from './standard/body.gjs';
import StandardFooter from './standard/footer.gjs';
import StandardHeader from './standard/header.gjs';
import Super from '../core/modal.gjs';
import styles from './standard.module.scss';

export default class SpdsModalStandard extends Super {
  baseClass = 'spds-modal';
  defaultComponentName = 'Spds::Modal::Standard';
  modal = true;
  styles = styles;

  <template>
    <FlexColumn
      @tag="dialog"
      class={{this.classes}}
      data-test-spds-modal
      {{this.onInsert}}
      ...attributes
    >
      {{yield
        (hash
          Body=(component StandardBody)
          Footer=(component StandardFooter)
          Header=(component StandardHeader close=this.beforeClose)
          beforeClose=this.beforeClose
          close=this.close
        )
      }}
    </FlexColumn>
  </template>
}
